import { defineStore, acceptHMRUpdate } from 'pinia'

export const useRedirectStore = defineStore('redirect', {
  state: () => ({
    redirectMapping: {} as Record<string, string>,
    initialized: false,
    loading: false
  }),

  getters: {
    getRedirect: (state) => (currentUrl: string) => {
      return state.redirectMapping[currentUrl] || null;
    }
  },

  actions: {
    setInitialized(value: boolean) {
      this.initialized = value;
    },

    setLoading(value: boolean) {
      this.loading = value;
    },

    populate(redirectData: Record<string, string>) {
      this.redirectMapping = redirectData
      this.setInitialized(true);
    },

    reset() {
      this.$reset()
      this.initialized = false
      this.loading = false
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useRedirectStore, import.meta.hot))
}